export default "__VITE_ASSET__FVGMOXln__"